import { store } from "react-notifications-component";

const options = {
  insert: "top",
  container: "top-right",
  animationIn: ["animate__animated", "animate__fadeIn"],
  animationOut: ["animate__animated", "animate__fadeOut"],
  dismiss: {
    duration: 3000,
    onScreen: true,
    showIcon: true,
    pauseOnHover: true,
  },
};

const show = (title, message, type) => {
  options.title = title;
  options.message = message;
  options.type = type;

  store.addNotification(options);
};

export const success = (message) => {
  show("Sucesso", message, "success");
};

export const info = (message) => {
  show("Informação", message, "info");
};

export const warning = (message) => {
  show("Atenção", message, "warning");
};

export const danger = (message) => {
  show("Erro", message, "danger");
};

export const showLoading = (id) => {
  window.$(id || ".ibox-content").toggleClass("sk-loading");
};
